import React from 'react';
import { Dropdown, Menu, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const LANG_MAP = [
  { key: 'zh-CN', label: '简体中文' },
  { key: 'zh-TW', label: '繁體中文' },
  { key: 'en', label: 'English' },
  { key: 'ja', label: '日本語' },
];

export default function LanguageSelector(){
  const { i18n } = useTranslation();
  const menu = (
    <Menu style={{minWidth:120, whiteSpace:'nowrap'}}
      onClick={({ key }) => i18n.changeLanguage(key)}
      selectedKeys={[i18n.language]}
      items={LANG_MAP.map(l=>({ key:l.key, label:l.label }))}
    />
  );
  return (
    <Dropdown overlay={menu} placement="bottomRight">
      <Button icon={<GlobalOutlined />} type="text" style={{color:'#fff'}} />
    </Dropdown>
  );
}
